import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Popup } from 'semantic-ui-react';

const TableActions = ({ selectedCount, totalCount, onGenerateAccessData }) => (
    <React.Fragment>
        <div style={{ float: 'right' }}>
            Označeno <b>{selectedCount}</b> od <b>{totalCount}</b>.
        </div>
        <br /><br />

        <Popup
            trigger={
                <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    color="blue"
                    onClick={onGenerateAccessData}
                    disabled={selectedCount === 0}
                >
                    <Icon className="print" />
                    Štampanje
                </Button>
            }
            content="Generiši pristupne podatke"
            position="top center"
        />
    </React.Fragment>
);

TableActions.propTypes = {
    selectedCount: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    onGenerateAccessData: PropTypes.func.isRequired
};

export default TableActions;




// WEBPACK FOOTER //
// ./src/views/GenerateUsers/TableActions.js